module.exports = __webpack_public_path__ + "img/dim.b0b0bf80.png";